import { PlatformLocation } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { TokenService } from 'src/services/token.service';

@Component({
  selector: 'app-valid-termos',
  templateUrl: './valid-termos.component.html',
  styleUrls: ['./valid-termos.component.scss']
})
export class ValidTermosComponent implements OnInit {
  form: FormGroup;
  mauticFormSrc: any = null;
  user: any
  progress:boolean = false;
  apiUrl = 'https://app.colloca.com.br/form/submit';

  constructor(
    fb: UntypedFormBuilder,
    private pLocation: PlatformLocation,
    private sanitazer: DomSanitizer,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<ValidTermosComponent>,
    @Inject('LinkContrato') public LinkContrato: string,
    @Inject('LinkTermos') public LinkTermos: string,
    private TokenService: TokenService,
    private http: HttpClient
  ) { 

    this.form = fb.group({
      acceptTerm: [null, Validators.required],
      acceptContract: [null, Validators.required]
    })

  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('token'));
  }

  onSubmit(event: Event) {
    this.progress = true;
    
    const data = this.form.getRawValue();
    
        const formData = {
          'mauticform[email]': this.user.email || '',
          'mauticform[termo_aceito]': data.acceptTerm ? 'true' : 'false',
          'mauticform[sinatura_escolhida]': '0,00',
          'mauticform[plano_escolhido]': 'FREE',
          'mauticform[contrato_aceito]': data.acceptContract ? 'true' : 'false',
          'mauticform[formId]': '20',
          'mauticform[return]': '',
          'mauticform[formName]': 'concluircadastro2',
          'mauticform[messenger]': '1'
        };
    
        const headers = new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded'
        });
    
        const body = new URLSearchParams();
        for (const key in formData) {
          if (formData.hasOwnProperty(key)) {
            body.set(key, formData[key]);
          }
        }
    
        this.http.post(this.apiUrl, body.toString(), { headers, responseType: 'text' }).subscribe(
          response => {
            this.TokenService.atualizar();
            setTimeout(()=>{this.close()},3500);
          },
          error => {
            console.error(error);
          }
        );
      

    // this.http.save('candidate_terms', plan)
    //   .subscribe(
    //     (result: any) => {
    //       console.log('retorno', result);
    //     },
    //     err => this.errorReport.showMessage(err)
    //   )
      
  }

  close() {
    this.dialogRef.close();
  }
}
